import Button from "../button/Button";
import Modal from "../modal/Modal";

interface Props {
  isModalOpen: boolean;
  allowButtonClosed: boolean;
  handleStartCharging: () => void;
  isLoading?: boolean;
  handleClose?: () => void;
}

const ToastTimeExpired: React.FC<Props> = ({isModalOpen, isLoading, handleClose, allowButtonClosed, handleStartCharging}) => {
  return (
    <>
      <Modal 
        allowButtonClosed={allowButtonClosed}
        isOpen={isModalOpen}
        onClose={handleClose}
        title="Tempo de espera terminou"
        textEnterButton="Tentar novamente"
        handleEnterButton={handleStartCharging}
        isLoadingEnterButton={isLoading}
      >
        <p>
          Não identificamos um carro conectado para recarga. Verifique o plug e tente novamente.
        </p>      
      </Modal>
    </>
  );
};

export default ToastTimeExpired;
